import { MiList } from "@miplatform/components";
import { HOME_PHASE_MAP, PAGINATION } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IHomeListResponse } from "@miplatform/types";
import { OrderCardHomeField } from "../../Orders/OrdersList/OrderCardHomeField/OrderCardHomeField";
import { GetHomesParams, HomeFilter } from "../types";
import { HomeCardTitle } from "./HomeCardTitle";

interface HomeListProps {
  data: IHomeListResponse[];
  setData: (data: IHomeListResponse[]) => void;
  dataProvider: (params: GetHomesParams) => Promise<void>;
  filters: HomeFilter;
  search: string;
}

export function HomeList({
  data,
  setData,
  dataProvider,
  filters,
  search,
}: HomeListProps) {
  const { navigate } = useRouter();

  const sections = [
    {
      fieldset: [
        {
          label: "Start Date",
          field: "modifiedOn",
          type: "Date",
        },
        {
          label: "Closing Date",
          field: "closingDate",
          type: "Date",
        },
        {
          label: "Home Type",
          field: "homeType",
        },
        {
          label: "Current Order",
          field: "latestTemplateName",
        },
        {
          label: "Order Status",
          field: "latestOrderStatus",
        },
      ],
    },
  ];

  const renderCardFields = ({
    address,
    community,
    builder,
  }: {
    address: { city: string };
    community: string;
    builder: string;
  }) => (
    <OrderCardHomeField
      home={{
        address: { city: address.city },
        communityName: community,
        builderName: builder,
      }}
    />
  );

  const handleNavigate = ({ id }: { id: string }) => {
    navigate(`/homes/${id}`);
  };

  const getGroupedCriterias = filters.groupBy
    ? (item: {
        builder?: string;
        latestTemplateName?: string;
        phase?: string;
      }) => {
        if (filters.groupBy === "builder") {
          return item?.builder || "";
        }
        if (filters.groupBy === "latestTemplateName") {
          return item?.latestTemplateName || "";
        }
        if (filters.groupBy === "phase") {
          return item?.phase ? HOME_PHASE_MAP[item.phase].text : "";
        }

        return "";
      }
    : undefined;

  return (
    <MiList
      paginationMode={PAGINATION.SERVER}
      defaultPageSize={25}
      data-testid="homes-List"
      cardProps={{
        sections,
        renderTitle: (home: IHomeListResponse) => <HomeCardTitle home={home} />,
        onClick: handleNavigate,
        leftCardProps: {
          fieldset: [
            {
              field: "homeId",
              valueGetter: renderCardFields,
            },
          ],
          leftWidth: "40%",
        },
      }}
      viewType="card"
      groupedMode={!!filters.groupBy}
      showGroupCount
      groupedCriteria={getGroupedCriterias}
      refresh={filters}
      data={data}
      setData={setData}
      dataProvider={dataProvider}
      search={search}
    />
  );
}
